import { useAuth } from '@/auth';
import { checkAnyPermissions, PERMISSIONS } from '@/auth/permissions';

/**
 * Hook para verificar permisos relacionados con presupuestos
 */
export const usePresupuestosPermissions = () => {
  const { user } = useAuth();
  const userPermissions = user?.permissions || [];

  const canView = checkAnyPermissions(userPermissions, [
    PERMISSIONS.VIEW_PRESUPUESTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canCreate = checkAnyPermissions(userPermissions, [
    PERMISSIONS.CREATE_PRESUPUESTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canEdit = checkAnyPermissions(userPermissions, [
    PERMISSIONS.EDIT_PRESUPUESTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  const canDelete = checkAnyPermissions(userPermissions, [
    PERMISSIONS.DELETE_PRESUPUESTOS.name,
    PERMISSIONS.FULL_ACCESS.name,
  ]);

  // Permisos combinados para operaciones específicas
  const canIniciarPresupuesto = canCreate;
  const canRegistrarCobro = canCreate;
  const canEditarCobro = canEdit;
  const canEliminarCobro = canDelete;
  const canEditarMontoPresupuesto = canEdit;
  const canEliminarPresupuesto = canDelete;
  const canCargarDocumento = canCreate;
  const canEliminarDocumento = canDelete;
  const canDescargarDocumento = canView;

  return {
    // Permisos base
    canView,
    canCreate,
    canEdit,
    canDelete,

    // Permisos específicos
    canIniciarPresupuesto,
    canRegistrarCobro,
    canEditarCobro,
    canEliminarCobro,
    canEditarMontoPresupuesto,
    canEliminarPresupuesto,
    canCargarDocumento,
    canEliminarDocumento,
    canDescargarDocumento,

    // Permisos combinados útiles
    canManagePresupuestos: canCreate || canEdit || canDelete,
    hasAnyPermission: canView || canCreate || canEdit || canDelete,
  };
};
